export default __webpack_public_path__ + "static/about2-1eb044d3da3a3fb1ed5b90a95f0310b3.jpg";